// количество слайдов в сдайдере
const caseSlidesCount = document.querySelectorAll(
  ".case__slider .swiper-slide"
).length;

// case slider
const swiperCase = new Swiper(".case__slider", {
  loop: caseSlidesCount > 1, // если больше одного слайда включаем loop
  spaceBetween: 16,
  slidesPerView: 1,
  speed: 800,
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".case__slider-next",
    prevEl: ".case__slider-prev",
  },
  breakpoints: {
    768: {
      spaceBetween: 32,
    },
  },
  pagination: {
    el: ".case__slider-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});
